import { displayMatchTypes } from '@/common/components/MatchTypeEditor/constants'

export const amountFieldConfig = {
  matchTypes: [
    displayMatchTypes.is,
    displayMatchTypes.greaterThan,
    displayMatchTypes.lowerThan,
    displayMatchTypes.valueInRange,
  ],
}

export const incompleteBoundLabel = '…'

export const singleValueLabelPrefixes = {
  [displayMatchTypes.is]: '',
  [displayMatchTypes.greaterThan]: '> ',
  [displayMatchTypes.lowerThan]: '< ',
}

export const singleValueMatchTypeToConfigKey = {
  [displayMatchTypes.is]: 'eq',
  [displayMatchTypes.greaterThan]: 'gt',
  [displayMatchTypes.lowerThan]: 'lt',
  [displayMatchTypes.valueInRange]: null,
}
